<mat-toolbar class="fullscreen-toolbar" color="primary">
    <mat-toolbar-row>
        <div class="toolbar-content">
          <div style="display: flex; align-items: center; ">
            <h3 class="dialog-title" (click)="titleClicked.emit()">
              @if (titleTranslateKey) {
                {{ titleTranslateKey | translate }}
              } @else {
                {{ title }}
              }
            </h3>
            @if (titlePrefixContent) {
            <ng-container [ngTemplateOutlet]="titlePrefixContent"></ng-container>
            }
          </div>
            <span class="flex-spacer"></span>
            @if (additionalContent) {
            <ng-container [ngTemplateOutlet]="additionalContent"></ng-container>
            }
            @if (showAuditButton) {
            <button (click)="onAuditClick()" [disabled]="auditDisabled" mat-icon-button aria-label="Open audit">
                <mat-icon fontIcon="fa-history" fontSet="fas" style="font-size: 17px;align-content: center;"></mat-icon>
            </button>
            }
            @if (showCloseButton) {
            <a mat-icon-button (click)="onCloseClick()"  aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </a>
            }
        </div>
    </mat-toolbar-row>
</mat-toolbar>
